<template>
  <footer
    v-if="$store.state.activeStep === 'SelectPlanStep' || $store.state.activeStep === 'GiftForm'"
    class="footer c-bg-light mt-6">
    <div class="container">

      <section class="footer-section pt-4 pb-5 bt-1">
        <div class="footer-block footer-block--copyrights">
          <img class="logo" src="@/assets/images/logo.svg" />
          <p class="c-gray copy">Copyright © Fundacja Pismo</p>
          <ul class="footer__social">
            <li><a href="https://facebook.com/pismo.magazynopinii" class="facebook" target="_blank"></a></li>
            <li><a href="https://twitter.com/magazynpismo" class="twitter" target="_blank"></a></li>
            <li><a href="https://soundcloud.com/user-558495548" class="soundcloud" target="_blank"></a></li>
            <li><a href="mailto:redakcja@magazynpismo.pl" class="mail" target="_blank"></a></li>
            <li><a href="https://instagram.com/magazynpismo" class="instagram" target="_blank"></a></li>
            <li><a href="https://youtube.com/channel/UCuNt6wpsnEnl_i2Z1So4Gxg" class="youtube" target="_blank"></a></li>
            <li><a href="https://magazynpismo.pl/category/posluchaj/" class="podcast" target="_blank"></a></li>
          </ul>
        </div>
        <div class="footer-block footer-block--sitemap">
          <ul class="footer-links" v-html="$appInfo.footer_html"></ul>
        </div>
      </section>

      <section class="footer-section pb-4">
        <div class="footer">
                <div class="footer__row sponsors-container flex-container">
                    <div class="footer__left-block">
                        <div class="footer__sponsors footer__sponsors-2">
                            <span class="caption">Fundację Pismo  <span class="mobile-br">wspierają:</span></span>
                            <a id="mddp" href="https://www.osborneclarke.com/pl" target="_blank"><div class="footer_image" style="width: 240px;"><img  style="margin-bottom: 4px;" src="@/assets/images/Osborne_clarke.png"/></div>
                        </div>
                    </div>

                    <div class="footer__center-block footer__center-block-a">
                        <div class="footer__sponsors">
                            <span class="caption caphide">MBRIDGE</span>
                            <a id="mbridge" href="https://www.mbridge.pl/" target="_blank"><div class="footer_image"><img src="@/assets/images/mbridge.png"/></div></a>
                        </div>
                    </div>

                    <div class="footer__center-block footer__center-block-b">
                        <div class="footer__sponsors">
                            <span class="caption caphide">SALESMANAGO</span>
                            <a id="sm" href="https://www.salesmanago.pl/" target="_blank"><div class="footer_image"><img src="@/assets/images/logo-sm.svg"/></div></a>
                        </div>
                    </div>

                    <div class="footer__empty-block">
                        <div class="footer__sponsors">
			&nbsp;
			</div>
                    </div>

                    <div class="footer__right-block">
                        <div class="footer__sponsors">
                            <span class="caption">realizacja <span class="mobile-br"> serwisu:</span></span>
                            <a id="wlc" href="https://whitelabelcoders.com/" target="_blank"><div class="footer_image"><img src="@/assets/images/wlc.svg"/></div></a>
                        </div>
                    </div>
                </div>
	</div>
      </section>
    </div>

  </footer>
</template>

<script>
  import { mapGetters } from 'vuex';
  export default {
    name: 'SiteFooter',
    data() {
      return {
        footerLinks: [
          { text: 'Dla reklamodawców', url: '/'},
          { text: 'Dla autorów', url: '/'},
          { text: 'Regulamin', url: '/'},
          { text: 'Kontakt', url: '/'},
          { text: 'FAQ', url: '/'},
          { text: 'Wesprzyj Pismo', url: '/'},
        ]
      }
    },
    computed: {
      isSubscriptionFlow() {
        return this.activeStep === 'SelectPlanStep' || this.activeStep === 'GiftForm';
      },
      ...mapGetters({
        activeStep: 'GET_ACTIVE_STEP',
      })
    }
  }
</script>

<style lang="scss">
  @import '../scss/mixins';
  .footer {
    &-section {
      display: flex;
      flex-wrap: wrap;
    }
    &-block {
      margin-top: 2em;
      &--sitemap {
        width: 100%;
        @include respond-to('mobile') {
          width: 50%;
        }
        @include respond-to('desktop') {
          width: 66.66%;
        }
      }
      &--copyrights {
        width: 100%;
        @include respond-to('mobile') {
          width: 50%;
        }
        @include respond-to('desktop') {
          width: 33.33%;
        }
      }
      &--sponsors {
        width: 100%;
        @include respond-to('desktop') {
          width: 66.66%;
        }
      }
      &--development {
        width: 100%;
        @include respond-to('desktop') {
          width: 33.33%;
        }
      }
    }

    .logo {
      max-width: 150px;
      margin-bottom: 12px;
      display: inline-block;
      &--sponsor {
        max-height: 60px;
        margin-right: 1em;
      }
    }

    .copy {
      font-size: .9em;
    }

    &-links {
      color: var(--color-gray);
      margin: 0;
      columns: 1;
      @include respond-to('desktop') {
        columns: 2;
      }
      li {
        border-left: 2px solid var(--color-lightgray);
        padding: .25em 0 .25em 1em;
        text-transform: uppercase;
        font-size: var(--font-15);
      }
    }
    &__social {
      $social-icon: 50px;
      font-size: 0;
      li {
        display: inline-block;
      }
      a {
        display: inline-block;

        background: transparent url('../assets/images/social-icons.png') no-repeat 0 0;
        width: $social-icon;
        height: $social-icon;
        &.facebook {
          @include image-sprite($social-icon, 0);
        }
        &.twitter {
          @include image-sprite($social-icon, 1);
        }
        &.soundcloud {
          @include image-sprite($social-icon, 2);
        }
        &.mail {
          @include image-sprite($social-icon, 3);
        }
        &.instagram {
          @include image-sprite($social-icon, 4);
        }
        &.youtube {
          @include image-sprite($social-icon, 5);
        }
        &.podcast {
          @include image-sprite($social-icon, 6);
        }
      }
    }
  }

  .clearfix::after {
    content: "";
    clear: both;
    display: table;
  }
</style>
